export const SET_OPEN_SHIFT_FILTER = "app/OPEN_SHIFT_FILTER/SET";
